import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_PARENTS_CHILDREN } from './queries';
import type { User } from './types';

export const useParentsChildren = (options?: QueryHookOptions) =>
  useQuery<{
    user: User;
  }>(GET_PARENTS_CHILDREN, options);
